import { createStore } from 'vuex'
import power from './power/power.js'
export default createStore({
  modules: {
    power
  }
})
